export default __webpack_public_path__ + "game_bundle_step_bg.fbdd40.svg";